import {
  USER_LOGGED_IN,
  USER_PROFILE_RETURNED,
  USER_LOGGED_OUT
} from "../actions/types";

/**
 * Reduces incoming user actions to a new state
 *
 * @param {*} state
 * @param {*} action
 */
export default function user(state = {}, action = {}) {
  switch (action.type) {
    /**
     * Stores the user data locally upon login
     */
    case USER_LOGGED_IN:
      return { ...state, ...action.user };
    /**
     * Erase local user data upon logout
     */
    case USER_LOGGED_OUT:
      return {};
    /**
     * Locally update the user profile from the server
     */
    case USER_PROFILE_RETURNED:
      return { ...state, ...action.profile };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js